import { renderMarkdownParagraphs } from '../../lib/inline-markdown';

interface EditorTurnProps {
  text: string;
  streaming?: boolean;
}

export default function EditorTurn({ text, streaming }: EditorTurnProps) {
  return (
    <article className="mb-8 py-6" aria-label="The press">
      <div className="text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground mb-4 inline-flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-primary" aria-hidden="true" />
        The press
      </div>
      <div className="font-display text-[18px] leading-[1.5] text-foreground tracking-[-0.005em] [font-variation-settings:'opsz'_48,'SOFT'_60]">
        {renderMarkdownParagraphs(text)}
        {streaming && (
          <span className="inline-block w-[2px] h-[1.1em] bg-primary/70 align-text-bottom animate-pulse ml-0.5" aria-hidden="true" />
        )}
      </div>
    </article>
  );
}
